var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckedSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 0H3.5C1.84315 0 0.5 1.34315 0.5 3V12C0.5 13.6569 1.84315 15 3.5 15H12.5C14.1569 15 15.5 13.6569 15.5 12V3C15.5 1.34315 14.1569 0 12.5 0Z",
    fill: "#0064FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.22707 11.48C6.06784 11.48 5.91515 11.4167 5.80257 11.3041L3.17574 8.67724C3.11999 8.62146 3.07579 8.55525 3.04563 8.48238C3.01548 8.4095 2.99997 8.33139 3 8.25253C3.00006 8.09325 3.06338 7.94054 3.17604 7.82796C3.2887 7.71537 3.44148 7.65214 3.60075 7.6522C3.76002 7.65226 3.91275 7.71559 4.02534 7.82825L6.22707 10.0306L11.5816 4.67605C11.6942 4.56339 11.8469 4.50006 12.0062 4.5C12.1655 4.49994 12.3182 4.56317 12.4309 4.67576C12.5436 4.78834 12.6069 4.94105 12.6069 5.10033C12.607 5.2596 12.5438 5.41238 12.4312 5.52504L6.65217 11.3041C6.59636 11.3599 6.53008 11.4042 6.45714 11.4344C6.38419 11.4646 6.30601 11.4801 6.22707 11.48Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedSmall);
export default __webpack_public_path__ + "static/media/CheckedSmall.38d4ab043f2e87cab2f7f1adcbb26f87.svg";
export { ForwardRef as ReactComponent };